/* eslint-disable import/prefer-default-export */

import CheckboxGroup from '@components/ui/formElements/CheckboxGroup'
import Textarea from '@components/ui/formElements/Textarea'
import { Values, ReasonListItemField } from '@components/returns/types'
import additionalFieldsStyles from './additionalFields.module.scss'
import { ReasonDropdown } from './ReasonDropdown'
import { Radios } from './Radios'

export type AdditionalReasonFieldProps = {
  values: Values
  field?: ReasonListItemField
  handleOnAdditionalReasonSelection: (selection: string[]) => void
}

function AdditionalReasonField({
  field,
  values,
  handleOnAdditionalReasonSelection
}: AdditionalReasonFieldProps) {
  if (!field) return null
  const firstField = field.values[0]

  return (
    <div className={additionalFieldsStyles.returnsForm__additionalFields}>
      {field?.type === 'radio' && (
        <div
          className={
            additionalFieldsStyles.returnsForm__additionalFieldsRadiosWrapper
          }
        >
          <p
            className={
              additionalFieldsStyles.returnsForm__additionalFieldsRadiosLabel
            }
          >
            {field.label}
          </p>
          <Radios
            field={field}
            values={values}
            handleOnAdditionalReasonSelection={
              handleOnAdditionalReasonSelection
            }
          />
        </div>
      )}
      {field?.type === 'checkbox' && (
        <CheckboxGroup
          fields={field.values.map(item => ({
            ...item,
            isChecked: values.reason_detail?.includes(item.id) || false
          }))}
          onChange={selection =>
            handleOnAdditionalReasonSelection(
              selection.filter(item => item.isChecked).map(item => item.id)
            )
          }
        />
      )}
      {field?.type === 'dropdown' && (
        <ReasonDropdown
          field={field}
          values={values}
          handleOnAdditionalReasonSelection={handleOnAdditionalReasonSelection}
        />
      )}
      {field?.type === 'text' && (
        <Textarea
          id={firstField?.id}
          changeValue={({ [firstField?.id]: value }) =>
            handleOnAdditionalReasonSelection([
              `${firstField?.label} : ${value}`
            ])
          }
          maxLength={200}
          placeholder="Type your message here"
        />
      )}
    </div>
  )
}

export default AdditionalReasonField
